<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          cols="12"
        >
          <base-material-card
            color="primary"
            icon="mdi-bank-transfer"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Change Order Requests
              </div>
            </template>

            <v-row>
              <v-col
                class="xs"
                cols="12"
                sm="12"
                md="12"
              >
                <v-data-table
                  :headers="headers_order"
                  :items="getchangeorders"
                  :single-expand="singleExpand"
                  :expanded.sync="expanded"
                  :search="searchrquests"
                  sort-by="timestamp"
                  sort-desc
                  expand-icon="mdi-chevron-down"
                  item-key="timestamp"
                  show-expand
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                      color="white"
                    >
                      <v-toolbar-title>Currency Orders</v-toolbar-title>

                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      />
                      <v-text-field
                        v-model="searchrquests"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      />
                      <v-spacer />
                    </v-toolbar>
                  </template>

                  <template v-slot:item.idnum="{ item }">
                    {{ item.idnum }}
                  </template>
                  <template v-slot:item.timestamp="{ item }">
                    {{ format_time(item.timestamp) }}
                  </template>
                  <template v-slot:item.type="{ item }">
                    {{ format_amt(item.changeorder.DepositAmount) }}
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      color="black"
                      size="20"
                      class="ma-4"
                      @click="deleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>

                  <template v-slot:no-data>
                    Sorry, No info {{ sitedetails.idnum }}
                  </template>

                  <template v-slot:expanded-item="{ headers, item }">
                    <td
                      :colspan="headers.length"
                      class="white"
                    >
                      <v-row>
                        <v-col
                          lg="6"
                          md="6"
                        >
                          <v-card>
                            <v-card-title>
                              Coins
                            </v-card-title>
                            <v-list>
                              <v-list-item-group>
                                <v-list-item>
                                  Pennies: {{ format_amt(item.changeorder.Coin001) }}
                                </v-list-item>
                                <v-list-item>
                                  Nickels: {{ format_amt(item.changeorder.Coin005) }}
                                </v-list-item>
                                <v-list-item>
                                  Dimes: {{ format_amt(item.changeorder.Coin010) }}
                                </v-list-item>
                                <v-list-item>
                                  Quarters: {{ format_amt(item.changeorder.Coin025) }}
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-card>
                        </v-col>
                        <v-col
                          lg="6"
                          md="6"
                        >
                          <v-card>
                            <v-card-title>
                              Notes
                            </v-card-title>
                            <v-list>
                              <v-list-item-group>
                                <v-list-item>
                                  Ones: {{ format_amt(item.changeorder.Notes1) }}
                                </v-list-item>
                                <v-list-item>
                                  Fives: {{ format_amt(item.changeorder.Notes5) }}
                                </v-list-item>
                                <v-list-item>
                                  Tens: {{ format_amt(item.changeorder.Notes10) }}
                                </v-list-item>
                                <v-list-item>
                                  Twenties: {{ format_amt(item.changeorder.Notes20) }}
                                </v-list-item>
                                <v-list-item>
                                  Fifties: {{ format_amt(item.changeorder.Notes50) }}
                                </v-list-item>
                                <v-list-item>
                                  Hundreds: {{ format_amt(item.changeorder.Notes100) }}
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-spacer />

                        <v-btn
                          color="primary"
                          @click="markfilled(item)"
                        >
                          mark complete
                        </v-btn>
                        <v-btn color="warning">
                          Remove
                        </v-btn>
                      </v-row>
                    </td>
                  </template>
                </v-data-table>

                <v-data-table
                  :headers="headers_filled_order"
                  :items="getfilledchangeorders"
                  :single-expand="singleExpandFilled"
                  :expanded.sync="expandedfilled"
                  :search="searchfilledorders"
                  sort-by="timestamp"
                  sort-desc
                  expand-icon="mdi-chevron-down"
                  item-key="timestamp"
                  show-expand
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                      color="white"
                    >
                      <v-toolbar-title>Filled Orders</v-toolbar-title>

                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      />
                      <v-text-field
                        v-model="searchfilledorders"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      />
                      <v-spacer />
                    </v-toolbar>
                  </template>

                  <template v-slot:item.idnum="{ item }">
                    {{ item.idnum }}
                  </template>
                  <template v-slot:item.timestamp="{ item }">
                    {{ format_time(item.timestamp) }}
                  </template>
                  <template v-slot:item.type="{ item }">
                    {{ format_amt(item.changeorder.DepositAmount) }}
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-icon
                      color="black"
                      size="20"
                      class="ma-4"
                      @click="deleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>

                  <template v-slot:no-data>
                    Sorry, No info {{ sitedetails.idnum }}
                  </template>

                  <template v-slot:expanded-item="{ headers, item }">
                    <td
                      :colspan="headers.length"
                      class="white"
                    >
                      <v-row>
                        <v-col
                          lg="6"
                          md="6"
                        >
                          <v-card>
                            <v-card-title>
                              Coins
                            </v-card-title>
                            <v-list>
                              <v-list-item-group>
                                <v-list-item>
                                  Pennies: {{ format_amt(item.changeorder.Coin001) }}
                                </v-list-item>
                                <v-list-item>
                                  Nickels: {{ format_amt(item.changeorder.Coin005) }}
                                </v-list-item>
                                <v-list-item>
                                  Dimes: {{ format_amt(item.changeorder.Coin010) }}
                                </v-list-item>
                                <v-list-item>
                                  Quarters: {{ format_amt(item.changeorder.Coin025) }}
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-card>
                        </v-col>
                        <v-col
                          lg="6"
                          md="6"
                        >
                          <v-card>
                            <v-card-title>
                              Notes
                            </v-card-title>
                            <v-list>
                              <v-list-item-group>
                                <v-list-item>
                                  Ones: {{ format_amt(item.changeorder.Notes1) }}
                                </v-list-item>
                                <v-list-item>
                                  Fives: {{ format_amt(item.changeorder.Notes5) }}
                                </v-list-item>
                                <v-list-item>
                                  Tens: {{ format_amt(item.changeorder.Notes10) }}
                                </v-list-item>
                                <v-list-item>
                                  Twenties: {{ format_amt(item.changeorder.Notes20) }}
                                </v-list-item>
                                <v-list-item>
                                  Fifties: {{ format_amt(item.changeorder.Notes50) }}
                                </v-list-item>
                                <v-list-item>
                                  Hundreds: {{ format_amt(item.changeorder.Notes100) }}
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-card>
                        </v-col>
                      </v-row>
                    </td>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  var numeral = require('numeral')

  export default {
    name: 'Depositusersbysite',
    props: ['id'],
    data: () => ({
      tab: 1,
      searchfilledorders: '',
      searchrquests: '',
      tabs: [
        {
          text: 'Post Deposit',
          icon: 'mdi-mailbox-open-up-outline'
        },
        {
          text: 'Order Currency',
          icon: 'mdi-account-cash-outline'
        },
        {
          text: 'Order Bags',
          icon: 'mdi-shopping-outline'
        },

      ],
      loading: false,
      dialog: false,
      e1: 1,
      steps: 2,
      dialoginfo: false,
      search: '',
      searchorder: '',
      searchorderfilled: '',
      searchbags: '',
      expanded: [],
      expandedfilled: [],

      expanded_deposits: [],
      expanded_bags: [],
      singleExpand: true,
      singleExpandFilled: true,
      sitedetails: '',
      snackbar: false,
      timeout: 5000,
      alertmessage: '',
      numeric_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
      ],
      currency_by_thousands_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 1000 === 0 || 'Available only by thousands',
      ],
      tens_by_hundreds_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 100 === 0 || 'Available only by hundreds',
      ],
      fives_by_hundreds_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 100 === 0 || 'Available only by hundreds',
      ],
      ones_by_hundreds_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 100 === 0 || 'Available only by hundreds',
      ],
      pennies_by_fiftycents_only: [
        v => !isNaN(v) || 'Please format as 0.00',
        v => (v) % 0.50 === 0 || 'Available only by 0.50',
      ],
      nickles_by_two_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 2 === 0 || 'Available only by twos',
      ],
      dimes_by_five_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 5 === 0 || 'Available only by fives',
      ],
      quarters_by_ten_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
        v => (v) % 10 === 0 || 'Available only by tens',
      ],
      tracking_rule: [
        v => !!v || 'Tracking ID is required',
        v => v.length === 22 || 'Tracking ID must be 22 digits',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
      ],
      bag_rule: [
        v => !!v || 'Bag ID is required',
        v => v.length === 9 || 'Bag ID must be 9 digits',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
      ],
      // actual_delivery_date: obj[key].actual_delivery_date,
      // carrier_status_code: obj[key].carrier_status_code,
      // carrier_status_description: obj[key].carrier_status_description,
      // events: obj[key].events,
      // ship_date: obj[key].ship_date,
      // status_code: obj[key].status_code,
      // status_description: obj[key].status_description,
      // tracking_number: obj[key].tracking_number
      headers_order: [
        { text: 'Site', align: 'left', value: 'siteid', sortable: true },
        { text: 'Group', align: 'left', value: 'group', sortable: true },
        { text: 'Order Date', align: 'left', value: 'timestamp', sortable: true },
        { text: 'Amount', align: 'center', value: 'type', sortable: true },
        { text: 'Actions', align: 'center', value: 'action', sortable: true },
      ],
      headers_filled_order: [
        { text: 'Site', align: 'left', value: 'siteid', sortable: true },
        { text: 'Group', align: 'left', value: 'group', sortable: true },
        { text: 'Filled', align: 'center', value: 'user.email', sortable: true },
        { text: 'Order Date', align: 'left', value: 'timestamp', sortable: true },
        { text: 'Filled Date', align: 'left', value: 'filledtime', sortable: true },
        { text: 'Amount', align: 'center', value: 'type', sortable: true },
      ],
      headers_bags: [
        { text: 'Ship Date', align: 'left', value: 'timestamp', sortable: true },
        { text: 'Tracking ID', align: 'left', value: 'trackingnumber', sortable: true },
        { text: 'Amount', align: 'center', value: 'type', sortable: true },
        { text: 'Status', align: 'center', value: 'status', sortable: true },
      ],

      editedOrderIndex: -1,
      editedOrderItem: {
        BagNumber: '',
        TrackingNumber: '',
        clientid: '',
        // or LocationNumber but NOT BOTH
        DepositDate: '',
        BagNumber: '',
        Notes1: '',
        Notes2: '',
        Notes5: '',
        Notes10: '',
        Notes20: '',
        Notes50: '',
        Notes100: '',
        CurrencyAmount: '',
        Coin001: '',
        Coin005: '',
        Coin010: '',
        Coin025: '',
        CoinAmount: '',
        CheckCount: '',
        CheckAmount: '',
        DepositAmount: 0,
      },
      defaultOrderItem: {
        // or LocationNumber but NOT BOTH
        BagNumber: '',
        TrackingNumber: '',
        clientid: '',
        Notes1: '',
        Notes2: '',
        Notes5: '',
        Notes10: '',
        Notes20: '',
        Notes50: '',
        Notes100: '',
        CurrencyAmount: '',
        Coin001: '',
        Coin005: '',
        Coin010: '',
        Coin025: '',
        Coin200: '',
        CoinAmount: '',
        CheckCount: '',
        CheckAmount: '',
        DepositAmount: 0,
      },
      editedBagIndex: -1,
      editedBagItem: {
        small: '',
        med: '',
        large: '',
        totalbags: 0
      },
      defaultBagItem: {
        small: '',
        med: '',
        large: '',
        totalbags: 0
      },
      editedIndex: -1,
      editedItem: {
        BagNumber: '',
        TrackingNumber: '',
        clientid: '',
        // or LocationNumber but NOT BOTH
        BagNumber: '',
        Notes1: '',
        Notes2: '',
        Notes5: '',
        Notes10: '',
        Notes20: '',
        Notes50: '',
        Notes100: '',
        CurrencyAmount: 0,
        Coin100: '',
        Coin200: '',
        CoinAmount: '',
        CheckCount: '',
        CheckAmount: '',
        DepositAmount: 0,
      },
      defaultItem: {
        BagNumber: '',
        TrackingNumber: '',
        clientid: '',
        // or LocationNumber but NOT BOTH
        BagNumber: '',
        Notes1: '',
        Notes2: '',
        Notes5: '',
        Notes10: '',
        Notes20: '',
        Notes50: '',
        Notes100: '',
        CurrencyAmount: '',
        Coin100: '',
        Coin200: '',
        CoinAmount: '',
        CheckCount: '',
        CheckAmount: '',
        DepositAmount: 0,
      },
    }),

    computed: {
      available_balance () {
        let safebalance = this.$store.getters.balancevalues.total
        let totalcurrent = 0
        this.$store.getters.getChangeOrders.forEach(entry => {
          totalcurrent += entry.changeorder.DepositAmount
        })

        return numeral(safebalance - totalcurrent).format('$0.00')
      },
      totalcashheld () {
        let safebalance = this.$store.getters.balancevalues.total
        return numeral(safebalance).format('$0.00')
      },
      getchangeorders () {
        let allorders = []
        let orders = []
        allorders = this.$store.getters.getChangeOrders
        let orderlist = []
        if (!allorders) {
          console.log('nothing to do')
          return
        }
        for (let sitelog of allorders) {
          let requests = sitelog.requests

          let orderkeys = Object.keys(requests)
          let changerequests = Object.values(requests)
          changerequests.forEach((req, index) => {
            let cid = ''
            if (req.clientid) {
              cid = req.clientid
            }
            let rec = {
              orderkey: orderkeys[index],
              sitekey: req.sitekey,
              changeorder: req.changeorder,
              clientid: cid,
              siteid: req.siteid,
              sitekey: req.sitekey,
              group: req.group,
              timestamp: req.timestamp
            }
            orders.push(rec)
          })
        }
        return orders
      },
      getfilledchangeorders () {
        let filledorders = []
        let forders = []
        filledorders = this.$store.getters.getFilledChangeOrders
        let orderlist = []
        for (let sitelog of filledorders) {
          let requests = sitelog.requests
          let orderkeys = Object.keys(requests)
          let changerequests = Object.values(requests)
          changerequests.forEach((req, index) => {
            let rec = {
              orderkey: orderkeys[index],
              sitekey: req.sitekey,
              changeorder: req.changeorder,
              clientid: req.clientid,
              siteid: req.siteid,
              sitekey: req.sitekey,
              group: req.group,
              timestamp: req.timestamp,
              user: req.user,
              filledtime: moment(req.filledtime).format('YYYY-MM-DD HH:mm')
            }
            forders.push(rec)
          })
        }
        return forders
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      steps (val) {
        if (this.e1 > val) {
          this.e1 = val
        }
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },

    created () {
      this.id = this.$route.params.id
      this.getsitemap(this.id)
      this.$log.debug('LOADING THIS ID ', this.id)

      this.initialize()
    },
    beforeDestroy () {
      this.$store.dispatch('stoprealtimechangeorders')
      this.$store.dispatch('stoprealtimefilledchangeorders')
    },
    methods: {
      editItem (item) {
        this.editedIndex = this.alerts.indexOf(item)
        this.$log.debug('edited index is ', this.editedIndex, 'edited item was ', item, 'alerts array is ', this.alerts)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.alerts.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.alerts.splice(index, 1)) {
          this.$log.debug('site info is ', item.key)
          this.$store.dispatch('removechangeorder', item)
        }
      },
      gettopurl (nav) {
        let url = nav + this.id
        return url
      },
      initialize () {
        this.alerts = this.$store.getters.alerts
        this.depositusers = this.$store.getters.loadedPendingDeposits
        this.ar = this.$store.getters.postdeposits
      },
      nextStep (n) {
        if (n === this.steps) {
          this.e1 = 1
        } else {
          this.e1 = n + 1
        }
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('YYYY-MM-DD HH:mm')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      getsitemap (machineid) {
        this.$log.debug('sitemap')
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum === machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
            }
          }
        }
        let sitedata = {
          crypto_idnum: this.$route.params.id
        }
        // live data needs an array
        let liverec = []
        liverec.push(sitedata)
        this.$store.dispatch('loadallchangeorders')
        this.$store.dispatch('loadallfilledchangeorders')
        // go live
        this.$store.dispatch('initrealtimechangeorders')
        this.$store.dispatch('initrealtimefilledchangeorders')

        // this.$store.dispatch('loadchangeorders', this.$route.params.id)
      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      markfilled (item) {
        // we're going to pop in the clientID here when its marked filled
        // this lets us know which company filled it

        console.log('this item is ', item)
        this.$store.dispatch('markchangeorderfilled', item)

        // figure out which item it is
        // send the key to function to move and mark as processed
      },
      savecurrencyorder () {
        let max_order_total = 1000
        let totalcurrent = this.editedOrderItem.DepositAmount // this order
        this.$store.getters.getChangeOrders.forEach(entry => {
          totalcurrent += entry.changeorder.DepositAmount // all the other un-delivered orders
        })
        if (totalcurrent > max_order_total) {
          this.alertmessage = 'Your total current change order is greater than the maximum, please adjust it under ' + numeral(max_order_total).format('$0.00')
          this.snackbar = true
          return
        }
        let changeorder = this.editedOrderItem
        let rec = {
          siteid: this.sitedetails.idnum,
          safeid: this.id,
          changeorder: changeorder,
          timestamp: Date.now()
        }
        this.editedOrderItem = this.defaultOrderItem // reset values
        this.alertmessage = 'Your order has been recorded, it will be delivered on the next business day. Please note same day delivery is not available'
        this.snackbar = true
        this.$store.dispatch('createChangeOrder', rec)
        this.tab = 0
        // this.$store.dispatch('loadchangeorders', this.$route.params.id)
      },
    },
  }
</script>
